var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSource8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2.667,
    fill: "#000",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 15.5,
    height: 15.5,
    rx: 2.417,
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.807 6.182c.007.35.12.618.339.802.215.191.463.287.745.287.291 0 .545-.096.76-.287.212-.184.321-.451.328-.802-.007-.361-.116-.634-.328-.818a1.16 1.16 0 00-.76-.265c-.282 0-.53.088-.745.265-.219.184-.332.457-.339.818zM5.578 9.448c.007-.733.306-1.302.896-1.709a2.227 2.227 0 01-.531-.682 1.582 1.582 0 01-.224-.854c.007-.632.22-1.155.64-1.568.396-.41.907-.618 1.532-.625.635.007 1.154.216 1.557.625.406.413.613.936.62 1.568 0 .33-.068.615-.204.854a2.539 2.539 0 01-.552.682c.59.407.89.976.896 1.709-.007.684-.23 1.23-.672 1.64-.448.42-.996.634-1.645.641-.646-.007-1.186-.22-1.62-.64-.455-.41-.686-.957-.693-1.641zm1.089-.01c.007.347.132.631.375.853.232.233.515.35.849.35.343 0 .631-.117.864-.35.236-.222.358-.506.365-.854-.007-.354-.129-.642-.365-.864a1.253 1.253 0 00-1.713 0 1.15 1.15 0 00-.375.864z",
    fill: "#000",
    fillOpacity: 0.6
  })));
}
export default SvgSource8;